function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import gettext from 'js-utils/gettext';
import { isThenable } from 'js-utils/feature-detection';
import { TYPE_NEUTRAL, TYPE_ERROR } from '../../notification/constants';
import { isMediumDown } from '../../utils/mediaQueries';
import SvgAlertChunky from '../../iconography/icons/AlertChunky';
import SvgCheckChunky from '../../iconography/icons/CheckChunky';
import find from 'lodash/find';

var withNotification = function withNotification(Component) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(WithNotificationWrapper, _PureComponent);

    function WithNotificationWrapper() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, WithNotificationWrapper);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(WithNotificationWrapper)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "_handleOnAddOrRemoveFromCollection", function (_ref) {
        var eventId = _ref.eventId,
            value = _ref.value,
            isChecked = _ref.isChecked;
        var _this$props = _this.props,
            onAddOrRemoveEventToCollection = _this$props.onAddOrRemoveEventToCollection,
            userCollections = _this$props.userCollections;

        if (onAddOrRemoveEventToCollection) {
          var promise = onAddOrRemoveEventToCollection({
            value: value,
            isChecked: isChecked,
            eventId: eventId
          });

          if (isThenable(promise)) {
            promise.then(function () {
              var _find = find(userCollections, ['id', value]),
                  name = _find.name,
                  href = _find.href;

              _this._displaySuccessNotification({
                name: name,
                href: href,
                isSaved: isChecked
              });
            }).catch(function (err) {
              var msg = isChecked ? gettext('Unable to add event to collection') : gettext('Unable to remove event from collection');

              if (err === 'REACH_MAX_EVENTS') {
                msg = gettext('Unable to add any more events to this collection');
              }

              _this._displayErrorNotification({
                msg: msg
              });
            });
          }
        }
      });

      _defineProperty(_assertThisInitialized(_this), "_handleOnCreateCollection", function (name, eventIdArray) {
        var onCreateCollection = _this.props.onCreateCollection;

        if (onCreateCollection) {
          var promise = onCreateCollection(name, eventIdArray);

          if (isThenable(promise)) {
            promise.then(function (collectionId) {
              return _this._displaySuccessNotification({
                name: name,
                href: "/c/".concat(collectionId),
                isSaved: true
              });
            }).catch(function () {
              return _this._displayErrorNotification({
                msg: gettext('There was an error creating the collection')
              });
            });
          }
        }
      });

      _defineProperty(_assertThisInitialized(_this), "_handleOnSaveEvent", function (eventId, isSaved) {
        var onSaveEvent = _this.props.onSaveEvent;

        if (onSaveEvent) {
          var promise = onSaveEvent(eventId, isSaved);

          if (isThenable(promise)) {
            promise.then(function () {
              return _this._displaySuccessNotification({
                isSaved: isSaved,
                name: gettext('Likes'),
                href: '/mytickets'
              });
            }).catch(function () {
              return _this._displayErrorNotification({
                msg: gettext('There was a problem saving the event')
              });
            });
          }
        }
      });

      _defineProperty(_assertThisInitialized(_this), "_displaySuccessNotification", function (_ref2) {
        var isSaved = _ref2.isSaved,
            name = _ref2.name,
            href = _ref2.href;
        var markup = gettext('Event added to <a href=%(href)s>%(name)s</a>.', {
          name: name,
          href: href
        });

        if (!isSaved) {
          markup = gettext('Event removed from <a href=%(href)s>%(name)s</a>.', {
            name: name,
            href: href
          });
        }

        return _this._handleShowNotification({
          children: //eslint-disable-next-line
          React.createElement("span", {
            dangerouslySetInnerHTML: {
              __html: markup
            }
          }),
          iconType: isSaved ? React.createElement(SvgCheckChunky, null) : '',
          type: TYPE_NEUTRAL
        });
      });

      _defineProperty(_assertThisInitialized(_this), "_displayErrorNotification", function (_ref3) {
        var msg = _ref3.msg;
        return _this._handleShowNotification({
          iconType: React.createElement(SvgAlertChunky, null),
          children: msg,
          type: TYPE_ERROR
        });
      });

      _defineProperty(_assertThisInitialized(_this), "_handleShowNotification", function (_ref4) {
        var children = _ref4.children,
            type = _ref4.type,
            iconType = _ref4.iconType;
        var _this$props2 = _this.props,
            addMainNotification = _this$props2.addMainNotification,
            userCollections = _this$props2.userCollections,
            addOverlayNotification = _this$props2.addOverlayNotification; // Necessary to check existence of userCollections
        // A truthy values determines rendering of
        // modal/dropdown when saving an event.

        if (isMediumDown() && userCollections && addOverlayNotification) {
          addOverlayNotification({
            children: children,
            type: type,
            iconType: iconType,
            hasCloseButton: true,
            shouldFloatAboveContent: true,
            shouldAnimate: true,
            fullWidth: true
          });
        } else if (addMainNotification) {
          addMainNotification({
            children: children,
            type: type,
            iconType: iconType,
            isNotificationSticky: true,
            hasCloseButton: true
          });
        }
      });

      return _this;
    }

    _createClass(WithNotificationWrapper, [{
      key: "render",
      value: function render() {
        return React.createElement(Component, _extends({}, this.props, {
          onSaveEvent: this._handleOnSaveEvent,
          onAddOrRemoveEventToCollection: this._handleOnAddOrRemoveFromCollection,
          onCreateCollection: this._handleOnCreateCollection
        }));
      }
    }]);

    return WithNotificationWrapper;
  }(PureComponent), _defineProperty(_class, "propTypes", {
    onSaveEvent: PropTypes.func,
    addMainNotification: PropTypes.func,
    addOverlayNotification: PropTypes.func,
    onAddOrRemoveEventToCollection: PropTypes.func,
    onCreateCollection: PropTypes.func,
    userCollections: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.string,
      href: PropTypes.string,
      eventCount: PropTypes.number
    }))
  }), _temp;
};

export default withNotification;